import {
  createRef,
  type Dispatch,
  type SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react';
import { type UserSignupType } from '../../../types/UserSignup';

import styles from './PIN.module.scss';

interface IPINProps {
  numberOfDigits: number;
  handlePinValue?: Dispatch<SetStateAction<UserSignupType>>;
}

export const PIN = ({ numberOfDigits, handlePinValue }: IPINProps) => {
  const [pinValue, setPinValue] = useState(Array(numberOfDigits).fill('/'));
  const inputRefs = useRef([]);

  inputRefs.current = pinValue.map(
    (_, index) => (inputRefs.current[index] = createRef())
  );

  function handleChangeValue(value, pinValueIndex) {
    if (!value) return;

    setPinValue((oldPinValue) => {
      return oldPinValue.map((v, index) => {
        if (pinValueIndex === index) return value;
        return v;
      });
    });

    if (pinValueIndex < pinValue.length - 1) {
      inputRefs.current[pinValueIndex + 1].current.focus();
    }
  }

  function handleBackspacePress(event, pinValueIndex) {
    if (event.key !== 'Backspace') return;

    setPinValue((oldPinValue) => {
      return oldPinValue.map((value, index) => {
        if (index !== pinValueIndex) return value;
        return '/';
      });
    });

    if (pinValueIndex > 0) {
      if (event.target.value) {
        inputRefs.current[pinValueIndex].current.focus();
      } else {
        inputRefs.current[pinValueIndex - 1].current.focus();
      }
    }
  }

  useEffect(() => {
    if (!pinValue.includes('/')) {
      handlePinValue((oldState) => ({
        ...oldState,
        pin: pinValue.join(''),
      }));
    }
  }, [handlePinValue, pinValue]);

  return (
    <div className={`${styles['pin__container']} space-bottom`}>
      {pinValue.map((_, index) => {
        return (
          <input
            key={index}
            type="text"
            maxLength={1}
            onChange={(e) => handleChangeValue(e.target.value, index)}
            onKeyDown={(e) => handleBackspacePress(e, index)}
            ref={inputRefs.current[index]}
          />
        );
      })}
    </div>
  );
};
